import React, { useEffect, useState } from "react";

import { cn } from "@/lib/utils";
import useGlobalStore from "@/stores/useGlobalStore";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

import ModelIcon from "./ModelIcon";
import { Button } from "@/components/ui/button";

const AIModelSwitcher = ({ isMobile }) => {
  const [open, setOpen] = useState(false);
  const { availableModels, aiModel, setAiModel, fetchModels, isLoadingModels, currentModel } = useGlobalStore();
  const selectedModel = availableModels.find((model) => model.name === aiModel);

  const handleModelSelect = (modelName) => {
    setAiModel(modelName);
    setOpen(false);
  };

  useEffect(() => {
    fetchModels();
  }, [fetchModels]);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          size="sm"
          variant="outline"
          className={cn("rounded-xl bg-white border border-border-light", isMobile && "border-none bg-transparent")}
          aria-label="Chọn một mô hình"
          aria-expanded={open}
          aria-haspopup="menu"
          type="button"
        >
          <div className="flex flex-shrink-0 items-center justify-center overflow-hidden">
            {isLoadingModels ? (
              <div className="animate-pulse h-5 w-5 bg-gray-200 rounded-full"></div>
            ) : selectedModel ? (
              <ModelIcon name={selectedModel.name} color={selectedModel.color} />
            ) : (
              <ModelIcon name="AI" color="#4285F4" />
            )}
          </div>

          {!isMobile && <span className="flex-grow truncate text-left">{isLoadingModels ? "Loading models..." : selectedModel?.name || "Select model"}</span>}
        </Button>
      </PopoverTrigger>

      <PopoverContent className="w-64 p-2">
        <div className="text-sm font-medium mb-2 text-gray-700">Chọn mô hình AI</div>

        {isLoadingModels ? (
          <div className="py-2 text-center text-sm text-gray-500">Loading available models...</div>
        ) : availableModels.length === 0 ? (
          <div className="py-2 text-center text-sm text-gray-500">No models available</div>
        ) : (
          <div className="space-y-1">
            {availableModels.map((model) => (
              <div
                key={model.name}
                className={`flex items-center gap-2 p-2 rounded-md cursor-pointer ${model.name === aiModel ? "bg-gray-100" : "hover:bg-gray-50"}`}
                onClick={() => handleModelSelect(model.name)}
              >
                <ModelIcon name={model.name} color={model.color} />
                <div className="flex flex-col">
                  <span className="text-sm font-medium">{model.name}</span>
                </div>
              </div>
            ))}
          </div>
        )}
      </PopoverContent>
    </Popover>
  );
};

export default AIModelSwitcher;
